import { useState } from "react";
import { ChevronRight, ChevronLeft } from "@mui/icons-material";
import Slider from "react-slick";
import HomeSectionCard from './../HomeSectionCard/HomeSectionCard';

const RecentReviewProductsCarousel = ({ productId, products }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    // ✅ Fetch saved IDs safely
    const ids = JSON.parse(localStorage.getItem("recentProductIds") || "[]");

    // ✅ Filter + Sort + Safe Check
    const items = products
        ?.filter((p) => ids.includes(p.id))
        ?.filter((p) => p.id !== productId)
        ?.sort((a, b) => ids.indexOf(a.id) - ids.indexOf(b.id));

    // Ensure at least 4 slots are always present
    while (items?.length < 4 && items?.length > 0) {
        items.push(<div key={`placeholder-${items?.length}`} className="opacity-10" />);
    }

    const CustomPrevArrowComponent = (props) => {
        const { onClick, currentSlide } = props;
        return currentSlide > 0 ? (
            <button
                className="absolute left-1 top-[42%] -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-sm border-0 text-stone-800 flex items-center justify-center"
                onClick={onClick}
            >
                <ChevronLeft fontSize="small" />
            </button>
        ) : null;
    };

    const CustomNextArrowComponent = (props) => {
        const { onClick, currentSlide, slideCount } = props;
        return currentSlide < slideCount - 4 ? (
            <button
                className="absolute right-1 top-[42%] -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-sm border-0 text-stone-800 flex items-center justify-center"
                onClick={onClick}
            >
                <ChevronRight fontSize="small" />
            </button>
        ) : null;
    };

    const settings = {
        dots: false,
        infinite: false,
        arrows: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 3,
        beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
        prevArrow: <CustomPrevArrowComponent currentSlide={currentSlide} />,
        nextArrow: (
            <CustomNextArrowComponent
                currentSlide={currentSlide}
                slideCount={items?.length || 0}
            />
        ),
        responsive: [
            {
                breakpoint: 1440,
                settings: { slidesToShow: 4, slidesToScroll: 3 },
            },
            {
                breakpoint: 1200,
                settings: { slidesToShow: 4, slidesToScroll: 3 },
            },
            {
                breakpoint: 1024,
                settings: { slidesToShow: 3, slidesToScroll: 2 },
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 2, slidesToScroll: 1 },
            },
            {
                breakpoint: 640,
                settings: { slidesToShow: 2, slidesToScroll: 1 },
            },
            {
                breakpoint: 480,
                settings: { slidesToShow: 2, slidesToScroll: 1 },
            },
            {
                breakpoint: 360,
                settings: { slidesToShow: 2, slidesToScroll: 1 },
            },
        ],
    };

    return (
        items?.length > 0 && (
            <section className="pt-8 bg-white">
                <div className="max-w-7xl mx-auto bg-cream rounded-[28px] py-8 px-4 sm:px-8">
                    <div className="mb-8 text-center">
                        <h2 className="section-heading text-[28px] md:text-[32px] leading-9">
                            Recently Viewed
                        </h2>
                    </div>
                    <div className="relative">
                        <div className="w-full relative overflow-hidden">
                            <Slider {...settings}>
                                {items?.map((product) => (
                                    <div key={product.id}>
                                        <HomeSectionCard product={product} />
                                    </div>
                                ))}
                            </Slider>
                        </div>
                        {/* Section Decoration */}
                    </div>
                </div>
                <style>
          {`
            .slick-slide > div {
              margin: 0 8px; /* ✅ gap between products */
            }
            .slick-list {
              margin: 0 -8px; /* ✅ remove extra space from edges */
            }
          `}
        </style>
            </section>
        )
    );
};

export default RecentReviewProductsCarousel;
